module.exports = __webpack_public_path__ + "static/media/incompleteOnboard.61e6b5b5.svg";